import { AuthRepository } from "../repositories/AuthRepository";
import { UserEntity } from "../entities/User";

/**
 * Get Current User Use Case
 */
export class GetCurrentUserUseCase {
  constructor(private repository: AuthRepository) {}

  getCurrentUser(): UserEntity | null {
    return this.repository.getStoredUser();
  }

  isMasterAdmin(): boolean {
    const user = this.getCurrentUser();
    if (!user || user.is_master_admin === undefined) return false;

    // Handle both boolean true and string "1"
    if (typeof user.is_master_admin === "boolean") {
      return user.is_master_admin === true;
    }
    if (typeof user.is_master_admin === "string") {
      return user.is_master_admin === "1";
    }
    return false;
  }

  isAuthenticated(): boolean {
    return this.repository.isAuthenticated();
  }
}
